import React from 'react';
import { connect } from 'react-redux';
import {
  preview,
} from '../actions/general-actions';
import Play from './icons/Play';

import styles from '../../../../stylesheet/css/header-builder/preview-button.css';

const PreviewButton = ({ children, onClick, model }) => {
  return (
    <div className={styles.container}>
      <a
        href="#"
        className={styles.button}
        onClick={onClick}
      >
        <Play /> <label className={styles.label}>Preview</label>
      </a>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClick(e) {
      e.preventDefault();
      dispatch(preview());
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(PreviewButton);



// WEBPACK FOOTER //
// ./app/header-builder/components/PreviewButton.js